/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getExecutiveMembers } from "../../api/apiServices";
import '../Board/Board.css';



function Executives() {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const [executive, setExecutive] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [count, setCount] = useState(0);

    const pgNumber = [9, 18, 36, 99];
    const pgraphst = {
        WebkitLineClamp: pgNumber[count],
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        display: "-webkit-box",
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        getExecutiveMembers({
            company: "NTHC_Commodities_Ltd"
        }, { signal })
            .then((res) => {
                setExecutive(res)
            });
        return () => {
            controller.abort();
        };
    }, [])

    return (
        <div className="content">
            <h3 className="heading"> Management Team</h3>
            <div className="board-container">
                {executive && executive.length > 0 && executive.map((executiveObj, index) => (
                    <div className="board-items">
                        <div className="info" key={index}>
                            <img src={`${process.env.REACT_APP_BASE_URL}/getimage/team/${executiveObj.image}`} alt='executive' />
                            <h2>{executiveObj.name}</h2>
                            <p>{executiveObj.position}</p>
                        </div>
                        <div className="profile">
                            <div style={isOpen ? null : pgraphst}>
                                {executiveObj.profile && executiveObj.profile.split("$").map((item, index) => (
                                    <div>
                                        {index == 0 ? (
                                            <>
                                                <p>{item && item}</p>
                                            </>
                                        ) : (
                                            <div>
                                                {executiveObj.profile.length < executiveObj.profile.length + 1 && (
                                                    <>
                                                        <p>{item && item}</p>
                                                    </>
                                                )}
                                            </div>

                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className="read-more-less">
                                {executiveObj.profile && (
                                    <button
                                        style={{ marginTop: "0.5rem", display: "" }}
                                        type="submit"
                                        className="btn btn-success"
                                        onClick={() => getCountNumber(count, setCount)}
                                    >
                                        {count > 2 ? "Read less..." : "Read more..."}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                ))}
            </div>
        </div>
    )
}

export default Executives;

function getCountNumber(count, setCount) {
    if (count > 2) {
        setCount((count = 0));
    } else {
        setCount(count + 1);
    }
}
